/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_hero_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De l'idée au produit qui fonctionne. De zéro compétence à développeur autonome. D'une plateforme qui stagne à une machine à résultats. Quelle que soit votre situation de départ, l'objectif est le même : des résultats concrets en 90 jours maximum. Formation développement web, création de plateformes sur mesure, automatisation et stratégie digitale. Sans blabla, que de l'action.`)
};

const en_hero_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From idea to working product. From zero skills to independent developer. From a stagnant platform to a results machine. Whatever your starting point, the goal is the same: concrete results in 90 days or less. Web development training, custom platform creation, automation, and digital strategy. No nonsense, just action.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hero_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hero_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("hero_description", locale)
	if (locale === "fr") return fr_hero_description(inputs)
	return en_hero_description(inputs)
};